<svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm.614 12.285a.89.89 0 0 0-1.24 0l-7.1 6.927a.837.837 0 0 0 0 1.208l.81.792a.887.887 0 0 0 1.254-.015l4.196-4.294v10.242c0 .474.391.855.877.855h1.17a.864.864 0 0 0 .877-.855V16.903l4.196 4.294a.894.894 0 0 0 1.253.015l.812-.792a.837.837 0 0 0 0-1.208z" id="xvzki6dmaa"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="f2lfx6j99b" fill="currentColor">
            <use xlink:href="#xvzki6dmaa"/>
        </mask>
        <use fill="currentColor" xlink:href="#xvzki6dmaa"/>
        <g mask="url(#f2lfx6j99b)" fill="currentColor">
            <path d="M0 0h40v40H0z"/>
        </g>
    </g>
</svg>
